import React, {useState, useEffect, useRef} from "react";
import {Breadcrumb, Row, Col, Button, Anchor} from 'antd';
import { Link } from "gatsby";

import Layout from '../../components/layout';
import Routes from "../../constant/routes";
import {WEB_APP_URL, ALL_SERVICES, CALENDLY_URL} from '../../constant';
import FooterBox from '../../components/footerBox';
import ShowMoreCmp from '../../components/showMoreCmp';
import {useOnScreen} from '../../helpers/utils';

const ServiceTemplateCascade = ({title, items, image, metaDescription, url='submit-ticket'}) => {
  const [relatedServices, setRelatedServices] = useState([]);
  const endBlockRef = useRef();
  const isEndBlock = useOnScreen(endBlockRef);

  useEffect(() => {
    const path = window?.location.pathname;
    const services = ALL_SERVICES.filter(s => s.route !== path);
    setRelatedServices(services)
  }, []);
  return (
    <Layout style={{paddingTop: 0}} title={`TicketTamer - ${title}`} description={metaDescription}>
      <div className="Services__Background-Image">
        <Row className="max-width-container">
          <Col md={16} xs={24}>
            <Breadcrumb>
              <Breadcrumb.Item>
              <Link to={Routes.HOME}>Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Services</Breadcrumb.Item>
              <Breadcrumb.Item>{title}</Breadcrumb.Item>
            </Breadcrumb>
            
            <div className="DisplayBlackLeft Services__Title mt8 mb40">{title}</div>
            <div className="Service_Banner_Btns">
              <a className="Service_Banner_Btn" href={`${WEB_APP_URL}/${url}`}><Button type="primary" block>Get Instant Quote</Button></a>
              <a className="Service_Banner_Btn" href={CALENDLY_URL} target="_blank" rel="noreferrer"><Button block>Schedule Free Consultation</Button></a>
            </div>
          </Col>
          <Col md={8} xs={24}>
            <img src={image} alt="banner" className="Services__Image for-desktop" />
          </Col>
        </Row>
      </div>
      <div className="max-width-container">
        <Row gutter={[{md: 80, xs: 0}]}>
          <Col md={16} xs={24}>
                <div>
                  {items.map((item, idx) => (
                    <div key={`cascade_${idx}`}>
                      <ShowMoreCmp previewContent={
                        <div>
                          <div className="H2BlackLeft mb16" id={`question_${item.key}`}>{item.title}</div>
                          {item.preview}
                        </div>
                      } all={<div>
                          <div className="H2BlackLeft mb16" id={`question_${item.key}`}>{item.title}</div>
                          {item.content}
                          <div style={{textAlign: 'left'}} className="mb40 mt32">
                            <div className="BodyBlackLeft mb16">You'll love our service. We guarantee it.</div>
                            <div className="Service_Banner_Btns">
                              <a className="Service_Banner_Btn" href={`${WEB_APP_URL}/${url}`}><Button type="primary" block>Get Instant Quote</Button></a>
                              <a className="Service_Banner_Btn" href={CALENDLY_URL} target="_blank" rel="noreferrer"><Button block>Schedule Free Consultation</Button></a>
                            </div>
                          </div>
                        </div>} 
                          style={{marginBottom: 40}}
                        />

                    </div>
                  ))}
                </div>
          </Col>
          <Col md={8} xs={24}>
            <Anchor affix={!isEndBlock} offsetTop={100} className="for-desktop">
            {items.map(item => (<Anchor.Link key={`question_${item.key}`} href={`#question_${item.key}`} title={item.title} />))}
            </Anchor>
          </Col>
        </Row>
        <div className="H3BlackLeft mt80 mb40">Related Services</div>
        <Row gutter={[24, 24]}>
        {relatedServices.map((s, index) => (<Col md={8} xs={24} key={`related_service_${index}`}><Link to={s.route} className="Service-Link" style={{fontSize: 16}}>{s.title}</Link></Col>))}
        </Row>
        <br/>
        <br/>
      </div>
      <FooterBox title={title} url={url} />
      <div ref={endBlockRef}/>
    </Layout>
  );
}

export default ServiceTemplateCascade;
